import React, { Component } from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import moment from "moment";
import { hostServer } from "../actions/consts/host";
import { Table, Tooltip } from "antd";
import axios from "axios";
import { Link } from "react-router-dom";
import ic_phone from "../assets/images/ic-phone.svg";
import ic_telegram from "../assets/images/ic-telegram.svg";
import ic_mail from "../assets/images/ic-mail.svg";
import ic_sms from "../assets/images/ic-sms.svg";
import ic_webhook from "../assets/images/ic-webhook.svg";

const typeIcons = {
  sms: ic_sms,
  phone: ic_phone,
  telegram: ic_telegram,
  email: ic_mail,
  mail: ic_mail,
  webhook: ic_webhook,
};

const columns = [
  {
    title: "Type",
    dataIndex: "type",
    width: "10%",
    render: (type) => {
      return (
        <Tooltip title={type}>
          <img
            className="notif-icon"
            src={R.prop(type, typeIcons)}
            alt={R.prop(type, typeIcons)}
          />
        </Tooltip>
      );
    },
  },
  {
    title: "Monitor",
    dataIndex: "monitor",
    width: "25%",
    render: (monitor) => (
      <Link to={`/monitor/${monitor.id}`}>{monitor.url}</Link>
    ),
  },
  {
    title: "Recipient",
    dataIndex: "recipient",
    width: "20%",
  },
  {
    title: "Time",
    dataIndex: "creation_time",
    width: "30%",
  },
  {
    title: "Status",
    dataIndex: "status",
    width: "15%",
    align: "center",
    render: (status) => {
      if (status.is_sent === false) {
        return (
          <Tooltip title={status.message} placement="right">
            <p className="is-sent_failed">Failed</p>
          </Tooltip>
        );
      } else {
        return <p className="is-sent_success">Sent</p>;
      }
    },
  },
];

class AlertHistory extends Component {
  state = {
    data: [],
    pagination: {},
    loading: false,
  };

  componentDidMount() {
    this.fetch({ results: 10, page: 1 });
  }

  handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
    });
  };

  fetch = async (params = {}) => {
    this.setState({
      loading: true,
    });
    const header = {
      headers: {
        Authorization: `Token ${this.props.uid}`,
      },
    };
    const offset = (params.page - 1) * params.results;
    const { data } = await axios.get(
      `${hostServer}/api/v1/notification_history/?limit=${params.results}&offset=${offset}`,
      header
    );
    const getHost = R.prop("host");
    const getUrl = R.prop("url");
    const history = R.map((val) => ({
      status: { is_sent: val.is_sent, message: val.public_message },
      creation_time: moment(val.creation_time).format(
        "dddd, MMMM Do YYYY, h:mm:ss a"
      ),
      type: val.notification_type,
      recipient: R.isNil(val.recipient) ? "---" : val.recipient,
      monitor: {
        url: R.reduce(R.either, R.isNil)([getHost, getUrl])(val.monitor),
        id: val.monitor.id,
      },
    }));

    const pagination = { ...this.state.pagination };
    pagination.total = data.count;

    this.setState({
      loading: false,
      data: history(data.results),
      pagination,
    });
  };

  render() {
    return (
      <Table
        columns={columns}
        dataSource={this.state.data}
        pagination={this.state.pagination}
        loading={this.state.loading}
        onChange={this.handleTableChange}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  uid: state.auth.uid,
});

export default connect(mapStateToProps)(AlertHistory);
